import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/Nikhil/Desktop/nodal/website/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "architecture"
    }}>{`Architecture`}</h1>
    <p>{`While the `}<a parentName="p" {...{
        "href": "/nodal/api"
      }}>{`API`}</a>{` will provide you with the ground-truth documentation about all the abstractions in the library, it's useful to understand the big picture of how everything fits
together.`}</p>
    <p>{`Nodal is built with a 2-level architecture:`}</p>
    <p><img alt="Nodal Architecture" src={require("../../assets/img/nodal-structure.png")} /></p>
    <h2 {...{
      "id": "low-level-optim-layer"
    }}>{`Low-level `}<inlineCode parentName="h2">{`optim`}</inlineCode>{` layer`}</h2>
    <p>{`Low-level manipulation of `}<inlineCode parentName="p">{`Vector`}</inlineCode>{`s with `}<inlineCode parentName="p">{`Gradient`}</inlineCode>{`s. An `}<inlineCode parentName="p">{`Optimizer`}</inlineCode>{` provides a scheme for adjusting the learning rate multiplier on the gradient. We implemented a constant rate (`}<inlineCode parentName="p">{`BasicOptimizer`}</inlineCode>{`) and adaptive (`}<inlineCode parentName="p">{`TrustRegionOptimizer`}</inlineCode>{`) version, but also think it would be interesting to port some of the ideas from the ML field, e.g. `}<inlineCode parentName="p">{`RMSPropOptimizer`}</inlineCode>{`, `}<inlineCode parentName="p">{`AdamOptimizer`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "high-level-graph-layer"
    }}>{`High-level `}<inlineCode parentName="h2">{`graph`}</inlineCode>{` layer`}</h2>
    <p>{`Higher-level constructs like `}<inlineCode parentName="p">{`Node`}</inlineCode>{` and `}<inlineCode parentName="p">{`Edge`}</inlineCode>{` (produced from lightweight `}<inlineCode parentName="p">{`NodeSchema`}</inlineCode>{` and `}<inlineCode parentName="p">{`EdgeSchema`}</inlineCode>{`) are just collections of `}<inlineCode parentName="p">{`Vector`}</inlineCode>{`s. Constraints and forces can be exerted on the `}<inlineCode parentName="p">{`Vector`}</inlineCode>{`s through functions that generate `}<inlineCode parentName="p">{`Gradient`}</inlineCode>{`s. The entire graph is stored in a `}<inlineCode parentName="p">{`Storage`}</inlineCode>{` which may have different features including performant spatial lookup of elements and complex manipulation/traversal of the graph structure. A developer writes a `}<inlineCode parentName="p">{`Layout`}</inlineCode>{`, which is a graph layout procedure, e.g. `}<em parentName="p">{`i`}</em>{` iterations of force application, then `}<em parentName="p">{`j`}</em>{` iteractions of constrain projection, repeated for `}<em parentName="p">{`N`}</em>{` steps.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      